import * as React from 'react';
import { useDimensions, useSidebar } from '../hooks';
import { PusherContent } from './NavPusher.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElement = 'div';
function NavPusher(props) {
  const {
    children,
    className
  } = props;
  const {
    isMobile,
    isTablet
  } = useDimensions();
  const isOpen = useSidebar();
  return /*#__PURE__*/_jsx(PusherContent, {
    $open: isOpen && !isTablet,
    $isMobile: isMobile,
    className: className,
    children: children
  });
}
export default /*#__PURE__*/React.memo(NavPusher);